import styled from 'styled-components';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
`;

export default Wrap;
